export default {
  data() {
    return {
      previousRoute: null
    };
  },
  methods: {
    goBack() {
      this.$router.replace({
        name: this.previousRoute.name,
        params: {
          objectId: this.objectId
        }
      });
    }
  },
  beforeRouteEnter(_, from, next) {
    next(vm => {
      vm.previousRoute = from;
    });
  }
};
